function first(key) {
  const keyFn = typeof key === "function" ? key : (d) => d[key];
  return (items) => items.length ? keyFn(items[0]) : void 0;
}

export { first };
//# sourceMappingURL=first.js.map
